// extracted by mini-css-extract-plugin
export default {"logo":"ProviderMarks_logo__KrigD","mark":"ProviderMarks_mark__TZUkA"};